import React from "react";
import { ActionTypes } from "../../action-type";
import axiosInstance from "../../../services/axios";
// import axiosInstance from "../../services/axios";


export const FinishDebate = (team,virtual_id) => async(dispatch)=>{
    const response = await axiosInstance.put("/mark/finish",{team:team,virtual_id:virtual_id})
    const {data} = response
    dispatch({
        type:ActionTypes.FINISH_DEBATE,
        payload:data
    })
};